export const SaveIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.1665 6.5C4.1665 5.09987 4.1665 4.3998 4.43899 3.86502C4.67867 3.39462 5.06112 3.01217 5.53153 2.77248C6.06631 2.5 6.76637 2.5 8.1665 2.5H11.8332C13.2333 2.5 13.9334 2.5 14.4681 2.77248C14.9386 3.01217 15.321 3.39462 15.5607 3.86502C15.8332 4.3998 15.8332 5.09987 15.8332 6.5V17.5L9.99984 14.1667L4.1665 17.5V6.5Z"
        stroke="#475467"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
